import UpdatePassword from '../../Customer/UpdatePassword'

function BranchAdminOnboard () {
  return <UpdatePassword />
}

export default BranchAdminOnboard
